/* eslint-disable */
import React, { useState, useEffect, useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import Loadable from 'react-loadable';
import Skeleton from 'react-loading-skeleton';
import Swal from 'sweetalert2';
import fromUnixTime from 'date-fns/fromUnixTime';
import format from 'date-fns/format';
import { Spinner } from 'react-bootstrap';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Modal from 'react-bootstrap/Modal';
import Carousel from 'react-bootstrap/Carousel';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import PersonAddIcon from '@material-ui/icons/PersonAdd';

import { connect } from 'react-redux';
import BorderColorIcon from '@material-ui/icons/BorderColor';
import Toast from 'react-bootstrap/Toast';
import { getUserProfile } from '../../redux/reducers/userProfile.reducer';
import {
  server,
  get,
  apiValidation,
  prodOrDev,
  post,
  isWebView,
  copyToClipboardHybrid,
  detectNextLine,
  urlify,
  formatVideoUrl,
  updateUsageTrack,
  isIosApp,
  iosCaller,
  iosRedirect,
} from '../../Utilities';
import {
  getLanguageObject,
  getClientId,
  getClientUserId,
  getRoleArray,
  getAppLanguage,
} from '../../redux/reducers/clientUserId.reducer';
import {
  getCreditsAvailable,
  getCurrentDashboardData,
  getCurrentRedirectPath,
  getCurrentSccrolledHeight,
  getSubscribedTopicsArray,
} from '../../redux/reducers/dashboard.reducer';
import userAvatar from '../../assets/images/user.svg';
import { userProfileActions } from '../../redux/actions/userProfile.action';
import { firstTimeLoginActions } from '../../redux/actions/firsttimeLogin.action';
import { clientUserIdActions } from '../../redux/actions/clientUserId.action';
import { testsActions } from '../../redux/actions/tests.action';
import { courseActions } from '../../redux/actions/course.action';
import { AspectCards, CoursesCards, DashboardCards, LiveClassesCards, YettostartCourseModal } from '../Common';

import Tests from '../Tests/Tests';
import './Dashboard.scss';
import '../Common/ScrollableCards/ScrollableCards.scss';
import { admissionActions } from '../../redux/actions/admissions.action';
import { getCurrentBranding } from '../../redux/reducers/branding.reducer';
import {
  getComeBackFromTests,
  getFirstTimeLoginState,
} from '../../redux/reducers/firstTimeLogin.reducer';
import { studyBinActions } from '../../redux/actions/studybin.actions';
import { homeworkActions } from '../../redux/actions/homework.action';
import '../Login/DummyDashboard.scss';
import { dashboardActions } from '../../redux/actions/dashboard.action';
import { analysisActions } from '../../redux/actions/analysis.action';

import { conversationsActions } from '../../redux/actions/conversations.action';
// import DiwaliLights from '../Common/Festives/DiwaliLights/DiwaliLights';
// import ChristmasSnow from '../Common/Festives/ChristmasSnow/ChristmasSnow';
import BottomNavigation from '../Common/BottomNavigation/BottomNavigation';
import LazyLoadCustom from '../Common/LazyLoadCustom/LazyLoadCustom';
import PageHeaderNew from '../Common/PageHeader/PageHeaderNew';
import { ChevronRight, SearchSharp, SmartToy, WarningAmberOutlined } from '@mui/icons-material';
import BackdropLoader from '../Common/BackdropLoader/BackdropLoader';
import EmblaPeek from '../Login/EmblaCarousel';
import Footer from '../Login/Footer';
import CourseCardNew from '../Common/CourseCardNew/CourseCardNew';
import StudentAppointment from '../Appointments/StudentAppointment';
import AppointmentCardNew from '../Common/CourseCardNew/AppointmentCardNew';
import { deleteFcmTokenWeb, getTokenn, onMessageListener } from '../../Utilities/firebase';
import UserStats from './UserStats';
import MulyankanDash from './MulyankanDash';
import Partition from '../Common/Partition/Partition';
import FoldersDash from './FoldersDash';
import ChatbotButton from '../Chatbot/ChatbotButton';
import BottomNavSpacer from '../Common/BottomNavigation/BottomNavSpacer';
import FAQ from '../Common/PrivacyPolicy/FAQ';
// import DiwaliFireworks from '../Common/Festives/DiwaliLights/DiwaliCrackers';

const DashBoardAdmissions = Loadable({
  loader: () => import('./DashBoardAdmissions'),
  loading() {
    return <Skeleton count={20} />;
  },
});

const Dashboard = (props) => {
  const {
    clientId,
    creditsAvailable,
    clientUserId,
    dashboardData,
    setTestNameToStore,
    roleArray,
    appLanguage = 1,
    userProfile: { firstName, profileImage, lastName, contact, countryCode },
    clearProfile,
    clearClientIdDetails,
    setCourseActiveTabToStore,
    languageObject = {},
    setFileUrlToStore,
    history,
    scrolledHeight,
    setDashboardDataToStore,
    setTokenToStore,
    setLocationDataToStore,
    setSelectedQuestionArrayToStore,
    setTestResultArrayToStore,
    setTestStartTimeToStore,
    setTestTypeToStore,
    setNavbarDataToStore,
    setFirstTimeLoginToStore,
    setRoleArrayToStore,
    setTestIdToStore,
    setHomeworkLanguageTypeToStore,
    setEomrSolutionFileUrlToStore,
    setEomrFileUrlToStore,
    setTestEndTimeToStore,
    setGlobalMessageCountToStore,
    setCourseIdToStore,
    setAdmissionRoleArrayToStore,
    branding,
    comeBackFromTests,
    setFolderIdArrayToStore,
    setAnalysisStudentObjectToStore,
    setTestAnalysisTimeToStore,
    setTestLanguageToStore,
    redirectPath,
    firstTimeLogin,

    setSelectedCourseToStore,
    setSelectedChapterToStore,
    setSelectedSubjectToStore,
    setSelectedTypeToStore,
    setTestFormatToStore,
    setActiveTagsToStore,
    clearTests,
  } = props;
  const [time, setTime] = useState('');
  const [logginOutModal, setLogginOutModal] = useState(false);
  const [currentCountry, setCurrentCountry] = useState(''); // location
  const [currentState, setCurrentState] = useState(''); // location
  const [clientStatus, setClientStatus] = useState('');
  const [restrictionModal, setRestrictionModal] = useState(false);
  const [isLowBalance, setIsLowBalance] = useState(false);
  const [creditsDaysLeft, setCreditDaysLeft] = useState(100);
  const [notices, setNotices] = useState([]);
  const [isScrolled, setIsScrolled] = useState(false);
  const [attendance, setAttendance] = useState([]);
  const [role, setRole] = useState(1);
  const [allCourses, setAllCourses] = useState([]);
  const [myCourses, setMyCourses] = useState([]);
  const [admissions, setAdmissions] = useState({});
  const [studentLiveStream, setStudentLiveStream] = useState([]);
  const [data, setData] = useState({});
  const [hasLoaded, setHasLoaded] = useState(false);
  const [globalMessageCountState, setGlobalMessageCountState] = useState(0);
  const [showToast, setShowToast] = useState(false);
  const [optionsModal, setOptionsModal] = useState(false);
  const [sessionStatus, setSessionStatus] = useState(true);
  const [showCallbackModal, setShowCallbackModal] = useState(false);
  const [callbackContact, setCallbackContact] = useState('');
  const [selectedSlot, setSelectedSlot] = useState('9:00 AM - 11:00 AM');
  const [selectedDate, setSelectedDate] = useState('');
  const [slots, setSlots] = useState([]);
  const [newNotifications, setNewNotifications] = useState(false);
  const [issueDescription, setIssueDescription] = useState('');
  const [showMaintenanceAlert, setShowMaintenanceAlert] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [fcmTokenObject, setFCMTokenObject] = useState({});
  const [showAllCourses, setShowAllCourses] = useState(false);
  const [categories, setCategories] = useState([]);
  const [categoryView, setCategoryView] = useState('standard');
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [appointments, setAppointments] = useState([]);
  const [permissions, setPermissions] = useState({});
  const [numberOfCoursesCompleted, setNumberOfCoursesCompleted] = useState(0);
  const [yettostartCourse, setYettostartCourse] = useState(null); // yettostart course whose start date is being shown in the modal

  const doc = useRef();
  const openOptionsModal = () => {
    if (clientStatus === 'deleted') {
      setRestrictionModal(true);
      return;
    }
    setOptionsModal(true);
  };
  const closeOptionsModal = () => setOptionsModal(false);
  const [features, setFeatures] = useState([]);
  const [isToken, setIsToken] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 538);
  const [nameDisplay, setNameDisplay] = useState(false);
  const [colors, setColors] = useState([
    '#d4a373',
    '#f08080',
    '#a0c4ff',
    '#abc4ff',
    '#84dcc6',
    '#b388eb',
    '#a7bed3',
    '#e7cee3',
    '#e4b4c2',
    '#fcd29f',
    '#d2e0bf',
  ]);

  useEffect(() => {
    const nowUTC = new Date();
    const nowIST = new Date(nowUTC.getTime());

    const hours = nowIST.getHours();
    const minutes = nowIST.getMinutes();

    const isInFirstWindow = hours === 13 && minutes >= 30 && minutes < 40;
    const isInSecondWindow = hours === 23 && minutes >= 0 && minutes < 10;

    if (isInFirstWindow || isInSecondWindow) {
      setShowMaintenanceAlert(hours);
    }

    if (isWebView && typeof window.Android.initializeZoomSDKV6_4_10 !== 'undefined') {
      get({}, '/generateTokenForZoomSdk').then((res) => {
        if (res && res.success) {
          window.Android.initializeZoomSDKV6_4_10(
            JSON.stringify({
              jwt_token: res.result,
            }),
          );
        }
      });
    } else if (isIosApp) {
      get({}, '/generateTokenForZoomSdk').then((res) => {
        if (res && res.success) {
          iosCaller('initializeZoomSDK', JSON.stringify({ jwt_token: res.result }));
        }
      });
    }
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const unreadMessageCountPromise = get(
          { client_user_id: clientUserId },
          '/getTotalUnReadMessageCountOfUser',
        );

        // Delay 1500ms before calling getSessionStatus
        const delayedSessionStatusPromise = new Promise((resolve) => {
          setTimeout(() => {
            resolve(
              get(
                { device: isWebView ? 'android' : isIosApp ? 'ios' : 'web', client_id: clientId },
                '/getSessionStatus',
              ),
            );
          }, 1500);
        });

        const [sessionStatusRes, unreadMessagesRes] = await Promise.all([
          delayedSessionStatusPromise,
          unreadMessageCountPromise,
        ]);

        // Process responses
        if (sessionStatusRes?.success && !sessionStatusRes.result.status) {
          setLogginOutModal(true);
          setTimeout(() => {
            setLogginOutModal(false);
            logout();
          }, 1000);
        } else {
          if (!sessionStorage.getItem('notisubscribed')) {
            if (isWebView && typeof window.Android.getFCMToken !== 'undefined') {
              window.Android.getFCMToken();
              window.Android.unsubscribeForNotification(); // remove this line after complete transition
            } else if (isIosApp) {
              iosCaller('getFCMToken');
            } else {
              if (isWebView && typeof window.Android?.subscribeForNotification !== undefined) {
                getTopicArray().then((topicArray) => {

                  window.Android.subscribeForNotification(JSON.stringify(topicArray));
                });
              } else if (!isIosApp) {
                getTokenn().then((res) => {
                  console.log(res);
                  const token = res;
                  setTokenToStore(token);

                  post(
                    {
                      client_user_id: clientUserId,
                      token: token,
                      device_type: 'web',
                      client_id: clientId,
                    },
                    '/updateFcmToken',
                  ).then((res) => {
                    if (res && res.success) {
                      console.log('success');
                      onMessageListener();
                    }
                  });
                });
              }
            }
            sessionStorage.setItem('notisubscribed', true);
          }
        }

        // if (notificationsRes?.success) {
        //   setNewNotifications(notificationsRes.result);
        // }

        if (unreadMessagesRes?.success) {
          setGlobalMessageCountState(unreadMessagesRes.result);
          setGlobalMessageCountToStore(unreadMessagesRes.result);
        }

        if (Number(creditsAvailable) < 1) {
          const path =
            roleArray.includes(4) || roleArray.includes(5)
              ? '/service-unavailable'
              : '/userservice-unavailable';
          history.replace({ pathname: path });
        }
      } catch (error) {
        console.error('Error in initial data fetching:', error);
      }
    };

    fetchData();
    setCourseActiveTabToStore('My Courses');
    get({ client_id: clientId }, '/getCourseCategoriesOfCoaching').then((res) => {
      if (res && res.success) {
        setCategories(res.result);
        setCategoryView(res.isTileView ? 'tiles' : 'standard');
      }
    });
  }, []);

  useEffect(() => {
    if (isWebView && typeof window.Android.enableScreenshot !== 'undefined') {
      window.Android.enableScreenshot();
    } else if (isIosApp) {
      iosCaller('enableScreenshot', '');
    }
    if (isWebView && typeof window.Android.enableSwipeRefresh !== 'undefined') {
      window.Android.enableSwipeRefresh();
    }

    if (isWebView && typeof window.Android.setIsRedirectExternal !== 'undefined') {
      window.Android.setIsRedirectExternal('true');
    } else if (isIosApp) {
      iosCaller('setIsRedirectExternal', 'true');
    }
    window.getFilesFromBackendToRemove = (arrOfFileIds, cuid) => {
      // const arr2 = JSON.parse(arr);
      // alert('hua');
      return JSON.stringify({ to_remove: [], to_retain: [] });
    };
    
    if (isWebView && typeof window.Android.setScreenOrientation !== 'undefined') {
      window.Android.setScreenOrientation('portrait');
    }

    return () => {
      if (isWebView && typeof window.Android.disableSwipeRefresh !== 'undefined') {
        window.Android.disableSwipeRefresh();
      }
    };
  }, []);

  const redirectToWhatsapp = () => {
    if (isIosApp) {
      iosRedirect(
        `https://wa.me/918851303866?text=Hi, I am the admin of ${data.client_name} application.`,
      );
    } else {
      window.location.href = `https://wa.me/918851303866?text=Hi, I am the admin of ${data.client_name} application.`;
    }
  };

  const closeCallbackModal = () => {
    setShowCallbackModal(false);
  };

  const sendClientTicket = () => {
    const payload = {
      client_id: clientId,
      client_user_id: clientUserId,
      preferred_date: selectedDate,
      preferred_slot: selectedSlot,
      callback_contact: callbackContact,
      ticket_description: issueDescription,
    };
    console.log(payload);
    post(payload, '/addClientTicket').then((res) => {
      const result = apiValidation(res);
      setShowCallbackModal(false);
      setSelectedSlot('9:00 AM - 11:00 AM');
      setSelectedDate('');
      setCallbackContact('');
      setIssueDescription('');
      if (res.success) {
        Swal.fire({
          title: 'Success',
          text: 'Thankyou for contacting us. You will recieve a callback from Ingenium really soon.',
          icon: 'success',
        });
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Oops',
          text: 'Something went wrong. Please try again after sometime.',
        });
      }
    });
  };
  useEffect(() => {
    // Function to update isMobile state based on window width
    function handleResize() {
      setIsMobile(window.innerWidth <= 538);
    }

    // Attach the event listener
    window.addEventListener('resize', handleResize);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    const nameDisplayTimer = setTimeout(() => {
      setNameDisplay(true);
    }, 0);
    return () => {
      clearTimeout(nameDisplayTimer);
    };
  }, []);

  const getTopicArray = () => {
    return new Promise((resolve, reject) => {
      const roleId = roleArray.includes(5)
        ? 5
        : roleArray.includes(4)
        ? 4
        : roleArray.includes(3)
        ? 3
        : roleArray.includes(2)
        ? 2
        : 1;

      // const currEnv = prodOrDev();
      const currEnv = 'production';
      const topicArray = [`${currEnv}institute${clientId}.0`, `${currEnv}user${clientUserId}.0`];

      if (roleArray.some((ele) => ele > 3)) {
        topicArray.push(`${currEnv}adminsupportchat${clientId}.0`);
      }

      const apiCallback = (resp) => {
        if (resp && resp.success) {
          const result = resp.result || [];

          const batchTopics = result.filter(ele => Boolean(ele.batch_name)).map((e) => `${currEnv}batch${e.client_batch_id}.0`);
          console.log(topicArray);
          resolve([...topicArray, ...batchTopics]);
        } else {
          console.error('Failed to fetch batches', resp);
          resolve(topicArray); // fallback to base topics only
        }
      };

      if (roleId === 2 || roleId === 1) {
        get({ client_id: clientId, client_user_id: clientUserId }, '/getBatchesOfStudent')
          .then(apiCallback)
          .catch((err) => {
            console.error('API error (student):', err);
            resolve(topicArray);
          });
      } else if (roleId === 3) {
        get({ client_id: clientId, client_user_id: clientUserId }, '/getBatchesOfTeacher')
          .then(apiCallback)
          .catch((err) => {
            console.error('API error (teacher):', err);
            resolve(topicArray);
          });
      } else {
        get({ client_id: clientId, client_user_id: clientUserId }, '/getAllBatchesOfCoaching')
          .then(apiCallback)
          .catch((err) => {
            console.error('API error (admin):', err);
            resolve(topicArray);
          });
      }
    });
  };

  const partsOfDay = () => {
    const hours = new Date().getHours();

    if (hours >= 0 && hours < 12) setTime('Good Morning 🌤');
    else if (hours >= 12 && hours <= 17) setTime('Good Afternoon ☀️');
    else if (hours >= 17 && hours < 21) setTime('Good Evening 🌜');
    else if (hours >= 21 && hours < 24) setTime('Good Evening 🌜');
  };

  useEffect(() => {
    if (clientStatus === 'deleted') {
      setRestrictionModal(true);
      return;
    }
    if (comeBackFromTests) history.push('/questiontaker');
  }, [comeBackFromTests, history]);

  useEffect(() => {
    if (redirectPath) {
      history.push(redirectPath);
    }
  }, [redirectPath, history]);

  useEffect(() => {
    const roleId = roleArray.includes(5)
      ? 5
      : roleArray.includes(4)
      ? 4
      : roleArray.includes(3)
      ? 3
      : roleArray.includes(2)
      ? 2
      : 1;

    setRole(roleId);
  }, [roleArray]);

  useEffect(() => {
    if (roleArray.includes(1) || roleArray.includes(2)) {
      const payload = {
        client_user_id: clientUserId,
      };
      get(payload, '/getAllScheduledClassesForStudent').then((res) => {
        if (res && res.success) {
          const result = res.result;
          setStudentLiveStream(result);
        }
      });
    }
  }, [roleArray, clientUserId]);

  useEffect(() => {
    partsOfDay();
    if (roleArray.includes(1) || roleArray.includes(2)) {
      if (currentCountry && currentState) {
        let limit = 8;
        if (clientId === 1104) limit = 20;
        get(
          { client_user_id: clientUserId, client_id: clientId, limit: limit },
          '/getRecentCourses',
        ).then((res) => {
          if (res && res.success) {
            const result = res.result;
            setAllCourses(result?.assigned_courses);
            setMyCourses(result?.subscribed_courses);
            let numberOfCoursesCompletedLocal = 0;
            result?.subscribed_courses?.forEach((c) => {
              if (c.completed_percentage > 95) {
                numberOfCoursesCompletedLocal += 1;
              }
            });
            setNumberOfCoursesCompleted(numberOfCoursesCompletedLocal);
            sessionStorage.setItem('karyakarta_courses_completed', numberOfCoursesCompletedLocal);
          }
        });
      } else {
        let limit = 8;
        if (clientId === 1104) limit = 20;
        get(
          { client_user_id: clientUserId, client_id: clientId, limit: limit },
          '/getRecentCourses',
        ).then((res) => {
          if (res && res.success) {
            const result = res.result;
            setAllCourses(result?.assigned_courses);
            setMyCourses(result?.subscribed_courses);
            let numberOfCoursesCompletedLocal = 0;
            result?.subscribed_courses?.forEach((c) => {
              if (c.completed_percentage > 95) {
                numberOfCoursesCompletedLocal += 1;
              }
            });
            setNumberOfCoursesCompleted(numberOfCoursesCompletedLocal);
            sessionStorage.setItem('karyakarta_courses_completed', numberOfCoursesCompletedLocal);
          }
        });
      }
      get(
        { client_user_id: clientUserId, client_id: clientId },
        '/getAllAppointmentsOfClient',
      ).then((res) => {
        if (res && res.success) {
          setAppointments(res.result);
        }
      });
    }
  }, [clientId, clientUserId, setDashboardDataToStore, currentCountry, currentState, roleArray]);

  useEffect(() => {
    setHomeworkLanguageTypeToStore('');
    setSelectedCourseToStore('');
    setSelectedChapterToStore('');
    setSelectedTypeToStore('');
    setSelectedSubjectToStore('');
    setEomrFileUrlToStore('');
    setEomrSolutionFileUrlToStore('');
    setSelectedQuestionArrayToStore([]);
  }, []);

  const logout = () => {
    const logoutPayload = {
      client_user_id: clientUserId,
      client_id: clientId,
      device_type: isWebView ? 'android' : isIosApp ? 'ios' : 'web',
    };
    if (isWebView && typeof window.Android.removeClientUserId !== 'undefined') {
      window.Android.removeClientUserId();
      if (typeof window.Android.deleteFCMToken !== 'undefined') {
        window.Android.deleteFCMToken();
      }
    } else if (isIosApp) {
      iosCaller('removeClientUserId');
      iosCaller('deleteFCMToken');
    } else {
      // web delete token
      deleteFcmTokenWeb();
    }
    post(logoutPayload, '/logoutUser')
      .then((res) => {
        const result = apiValidation(res);
        if (result) {
          history.push({ pathname: '/preload' });
          clearProfile();
          sessionStorage.clear();
          if (isWebView && typeof window.Android.unsubscribeForNotification !== 'undefined') {
            window.Android.unsubscribeForNotification();
          } else if (isIosApp) {
            // iosCaller('unsubscribeForNotification');
          }
          clearClientIdDetails();
          setFirstTimeLoginToStore(false);
        }
      })
      .catch(() => {
        history.push({ pathname: '/preload' });
      });
  };

  const setScrolling = () => {
    // setScrolledHeightOfDocumentToStore(
    //   window.pageYOffset !== undefined
    //     ? window.pageYOffset
    //     : (document.documentElement || document.body.parentNode || document.body).scrollTop,
    // );
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 70);
    };
    window.addEventListener('scroll', handleScroll);

    // Initial check in case user is already scrolled
    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const setDashboardInitally = (initdata) => {
    const result = initdata;

    setNotices(result.notice);
    setClientStatus(result.client_status);
    setAdmissions(result.admission || {});
    setAttendance(result.attendance);
    setData(result);
    setHasLoaded(true);
    if (result.averageConsumption) {
      const threshold = Number(result.averageConsumption) * 5;
      setIsLowBalance(creditsAvailable < threshold);
      if (!sessionStorage.getItem('visited') && (roleArray.includes(4) || roleArray.includes(5))) {
        setCreditDaysLeft(Math.ceil(creditsAvailable / Number(result.averageConsumption)));
      }
    }
    setDashboardDataToStore(result);

    const sorterArr = [];
    for (const prop in result.feature) {
      if (Object.prototype.hasOwnProperty.call(result.feature, prop))
        sorterArr.push([result.feature[prop], result.feature[prop].order, prop]);
    }

    const finalArr = sorterArr
      .sort((a, b) => a[1] - b[1])
      .reduce((acc, curr) => {
        acc.push({ ...curr[0], switcher: curr[2] });
        return acc;
      }, []);
    console.log(finalArr, 'hello');
    setFeatures(finalArr);
  };

  useEffect(() => {
    if (dashboardData.client_name && dashboardData.client_name != 'undefined') {
      document.title = dashboardData.client_name;
    }
    window.sendFCMTokenToWeb = (tokenjson) => {
      const tokenObject = JSON.parse(tokenjson);
      setFCMTokenObject(tokenObject);
    };
    setDashboardInitally(dashboardData);
    const roleId = roleArray.includes(5)
      ? 5
      : roleArray.includes(4)
      ? 4
      : roleArray.includes(3)
      ? 3
      : roleArray.includes(2)
      ? 2
      : 1;
    if (!sessionStorage.getItem('visited')) {
      if (isWebView && typeof window.Android.saveClientId !== 'undefined') {
        window.Android.saveClientId(String(clientId));
      } else if (isIosApp) {
        iosCaller('saveClientId', String(clientId));
      }

      get(
        {
          client_id: clientId,
          role_id: roleId,
          client_user_id: clientUserId,
          is_new: true,
        },
        '/getLoginPageInformation',
      ).then((res) => {
        if (res && res.success) {
          const result = res.result;
          document.title = result.client_name;
          setDashboardInitally(result);

          const sorterArr = [];
          for (const prop in result.feature) {
            if (Object.prototype.hasOwnProperty.call(result.feature, prop))
              sorterArr.push([result.feature[prop], result.feature[prop].order, prop]);
          }

          const finalArr = sorterArr
            .sort((a, b) => a[1] - b[1])
            .reduce((acc, curr) => {
              acc.push({ ...curr[0], switcher: curr[2] });
              return acc;
            }, []);

          setFeatures(finalArr);
          sessionStorage.setItem('visited', true);
        }
      });
    }
  }, [clientId, roleArray, setDashboardDataToStore]);

  useEffect(() => {
    if (
      Object.keys(fcmTokenObject).length &&
      fcmTokenObject.fcm_token &&
      fcmTokenObject.client_user_id
    ) {
      post(
        {
          client_user_id: fcmTokenObject.client_user_id,
          token: fcmTokenObject.fcm_token,
          device_type: isIosApp ? 'ios' : 'android',
          client_id: clientId,
        },
        '/updateFcmToken',
      ).then((res) => {
        if (res && res.success) {
          console.log('success');
        }
      });
    }
  }, [fcmTokenObject]);

  const [featureList, setFeatureList] = React.useState([]);
  const roleId = roleArray.includes(5)
    ? 5
    : roleArray.includes(4)
    ? 4
    : roleArray.includes(3)
    ? 3
    : roleArray.includes(2)
    ? 2
    : 1;

  useEffect(() => {
    get(
      {
        client_id: clientId,
        role_id: roleId,
        client_user_id: clientUserId,
      },
      '/getClientFeature3',
    ).then((res) => {
      if (res && res.success) {
        if (roleId === 1) {
          setNavbarDataToStore(
            res.result
              .filter(
                (elem) =>
                  elem.feature_name !== 'aboutUs' &&
                  elem.feature_name !== 'contactUs' &&
                  elem.feature_name !== 'connectWithUs' &&
                  elem.feature_name !== 'share' &&
                  elem.feature_name !== 'posters' &&
                  elem.feature_name !== 'videos' &&
                  elem.feature_name !== 'starPerformers' &&
                  elem.feature_name !== 'testimonial' &&
                  elem.feature_name !== 'admissionForm' &&
                  elem.feature_name !== 'admission' &&
                  elem.feature_name !== 'onlineAssignment' &&
                  elem.feature_name !== 'displayPage' &&
                  elem.feature_name !== 'chats' &&
                  elem.status !== 'deleted',
              )
              .map((elem, index) => ({ ...elem, id: index })),
          );
        } else {
          setNavbarDataToStore(
            res.result
              .filter(
                (elem) =>
                  elem.feature_name !== 'aboutUs' &&
                  elem.feature_name !== 'contactUs' &&
                  elem.feature_name !== 'connectWithUs' &&
                  elem.feature_name !== 'share' &&
                  elem.feature_name !== 'posters' &&
                  elem.feature_name !== 'videos' &&
                  elem.feature_name !== 'starPerformers' &&
                  elem.feature_name !== 'testimonial' &&
                  elem.feature_name !== 'admissionForm' &&
                  elem.feature_name !== 'admission' &&
                  elem.feature_name !== 'onlineAssignment' &&
                  elem.feature_name !== 'displayPage' &&
                  elem.feature_name !== 'myCourses' &&
                  elem.status !== 'deleted',
              )
              .map((elem, index) => ({ ...elem, id: index })),
          );
        }
      }
    });
  }, []);

  const shareThis = () => {
    console.log(data.appLink, data.app_share_message);
    if (navigator.share) {
      navigator
        .share({
          text: `${data.app_share_message ? data.app_share_message : ''} ${window.location.href}`,
        })
        .then(() => {
          console.log('Thanks for sharing!');
        })
        .catch((err) => console.log(err));
    } else {
      if (isWebView && typeof window.Android.share !== 'undefined') {
        Android.share(
          data.client_name,
          data.app_share_message ? data.app_share_message : data.appLink,
        );
      } else {
        setShowToast(true);
        copyToClipboardHybrid(data.app_share_message ? data.app_share_message : data.appLink);
      }
    }
  };

  const goToLiveClasses = () => {
    const { push } = history;
    setScrolling();
    if (clientStatus === 'deleted') {
      setRestrictionModal(true);
      return;
    }
    push({ pathname: '/liveclasses' });
  };

  const goToNoticeBoard = () => {
    const { push } = history;
    setScrolling();
    if (clientStatus === 'deleted') {
      setRestrictionModal(true);
      return;
    }
    push({ pathname: '/noticeboard' });
  };

  const goToAdmissions = () => {
    const { push } = history;
    setScrolling();
    if (clientStatus === 'deleted') {
      setRestrictionModal(true);
      return;
    }
    push({ pathname: '/admissions' });
  };

  const goToStudyBin = () => {
    const { push } = history;
    setScrolling();
    if (clientStatus === 'deleted') {
      setRestrictionModal(true);
      return;
    }
    setFolderIdArrayToStore([]);
    push({ pathname: '/studybin' });
  };

  const goToProfile = () => {
    const { push } = history;
    setScrolling();
    if (clientStatus === 'deleted') {
      setRestrictionModal(true);
      return;
    }
    push({ pathname: '/profile' });
  };

  const goToFees = () => {
    const { push } = history;
    setScrolling();
    if (clientStatus === 'deleted') {
      setRestrictionModal(true);
      return;
    }
    push('fees');
  };

  const goToAppointmentBooking = () => {
    const { push } = history;
    setScrolling();
    if (clientStatus === 'deleted') {
      setRestrictionModal(true);
      return;
    }
    push('all-appointments');
  };

  const goToTeacherFees = () => {
    const { push } = history;
    setScrolling();
    if (clientStatus === 'deleted') {
      setRestrictionModal(true);
      return;
    }
    push('teacherfees');
  };

  const goToNotifications = () => {
    const { push } = history;
    setScrolling();
    if (clientStatus === 'deleted') {
      setRestrictionModal(true);
      return;
    }
    push('notifications');
  };

  const goToHomeWorkCreator = () => {
    const { push } = history;
    setScrolling();
    clearTests();
    if (clientStatus === 'deleted') {
      setRestrictionModal(true);
      return;
    }
    push({ pathname: screen.width < 786 ? '/v2/notavailable' : '/v2/homeworkcreator', state: { letsGo: true } });
  };

  const goToSentTests = (type) => {
    const { push } = history;
    setScrolling();
    if (clientStatus === 'deleted') {
      setRestrictionModal(true);
      return;
    }
    push({ pathname: screen.width < 786 ? '/v2/notavailable' : '/all-tests', state: { testsType: type } });
  };

  const goToChats = () => {
    const { push } = history;
    setScrolling();
    // if (clientStatus === 'deleted') {
    //   setRestrictionModal(true);
    //   return;
    // }
    push({ pathname: '/conversations' });
  };

  const startHomework = (responseArray, testId, languageType = 'english', fileUrl, testFormat, testName) => {
    const { push } = history;
    setScrolling();
    if (clientStatus === 'deleted') {
      setRestrictionModal(true);
      return;
    }
    if (false) {
    } else {
      setTestResultArrayToStore(responseArray);
      setTestIdToStore(testId);
      setTestLanguageToStore(languageType);
      setTestTypeToStore('homework');
      setFileUrlToStore(fileUrl);
      setTestFormatToStore(testFormat);
      setTestNameToStore(testName)
      push('/questiontaker');
    }
  };

  const startLiveTest = (
    responseArray,
    startTime = 0,
    endTime = 0,
    testType,
    testId,
    languageType = 'english',
    analysisTime,
    fileUrl,
    testFormat,
    testName,
  ) => {
    const { push } = history;
    setScrolling();
    if (clientStatus === 'deleted') {
      setRestrictionModal(true);
      return;
    }

    setTestResultArrayToStore(responseArray);
    setTestEndTimeToStore(endTime);
    setTestNameToStore(testName)
    // setTestStartTimeToStore(startTime);
    setTestStartTimeToStore(Math.round(new Date().getTime() / 1000));
    setTestTypeToStore(testType);
    setTestIdToStore(testId);
    setFileUrlToStore(fileUrl);
    setTestFormatToStore(testFormat);
    setTestAnalysisTimeToStore(analysisTime);
    setTestLanguageToStore(languageType);
    push('/questiontaker');
  };

  const goToCoursesForTeacher = (name) => {
    const { push } = history;
    setScrolling();
    if (clientStatus === 'deleted') {
      setRestrictionModal(true);
      return;
    }
    push({ pathname: '/courses/teachercourse' });
  };

  const goToCourses = (type) => {
    console.log(type);
    const { push } = history;
    setScrolling();
    if (clientStatus === 'deleted') {
      setRestrictionModal(true);
      return;
    }
    push({ pathname: '/courses', state: { type: 'myCourses' } });
  };

  const goToBuyCourse = (id) => {
    const { push } = history;
    setScrolling();
    if (clientStatus === 'deleted') {
      setRestrictionModal(true);
      return;
    }
    push({
      pathname: `/courses/buyCourse/${window.btoa(clientId)}/${window.btoa(id)}`,
      state: { randomColor: colors[Math.floor(Math.random() * colors.length)] },
    });
  };

  const goToMyCourse = (id) => {
    const { push } = history;
    setScrolling();
    if (clientStatus === 'deleted') {
      setRestrictionModal(true);
      return;
    }
    // if (true) {
    if (false) {
    } else {
      setCourseIdToStore(id);
      push(clientId == 1104 ? '/courses/viewcourse' : '/courses/myCourse');
    }
  };

  const openYettostartCourseModal = (course) => {
    setScrolling();
    if (clientStatus === 'deleted') {
      setRestrictionModal(true);
      return;
    }
    setYettostartCourse(course);
  };

  const goToAddBatch = () => {
    const { push } = history;
    setScrolling();
    if (clientStatus === 'deleted') {
      setRestrictionModal(true);
      return;
    }
    push('/admissions/add/batch');
  };

  const addDetails = (type) => {
    setScrolling();
    if (clientStatus === 'deleted') {
      setRestrictionModal(true);
      return;
    }
    type === 'student'
      ? setAdmissionRoleArrayToStore(['1'])
      : type === 'teacher'
      ? setAdmissionRoleArrayToStore(['3'])
      : setAdmissionRoleArrayToStore(['4']);
    history.push({ pathname: '/admissions/add/details' });
  };

  const goToTeacherAnalysis = () => {
    setScrolling();
    if (clientStatus === 'deleted') {
      setRestrictionModal(true);
      return;
    }
    const { push } = history;
    // Swal.fire({
    //   title: 'Attention',
    //   text: 'Analysis feature is under maintenance for admins. However, users can see their own analysis.',
    //   icon: 'warning',
    // });
    push('/analysis/teacher');
  };
  const goToQuiz = () => {
    setScrolling();
    if (clientStatus === 'deleted') {
      setRestrictionModal(true);
      return;
    }
    const { push } = history;
    push('/dailyquiz');
  };

  const goToStudentAnalysis = () => {
    setScrolling();
    get({ client_user_id: clientUserId }, '/getOverallAnalysisOfStudent').then((res) => {
      if (res && res.success) {
        const result = res.result;
        result.first_name = firstName;
        result.last_name = lastName;
        result.isStudent = true;
        setIsLoading(false);
        setAnalysisStudentObjectToStore(result);
        history.push('/analysis/studentlist');
      } else {
        if (isWebView) {
          window.Android.showToast('Something went wrong');
        }
      }
    });
    // history.push({ pathname: '/all-tests' });
  };

  const gotToAttendance = () => {
    const { push } = history;
    setScrolling();
    if (clientStatus === 'deleted') {
      setRestrictionModal(true);
      return;
    }
    push('/attendance');
  };

  const goToDisplayPage = () => {
    const { push } = history;
    setScrolling();
    if (clientStatus === 'deleted') {
      setRestrictionModal(true);
      return;
    }
    push('/displaypage');
  };

  const goToCRM = () => {
    setScrolling();
    if (clientStatus === 'deleted') {
      setRestrictionModal(true);
      return;
    }
    history.push('/crm');
  };

  const goToUsage = (pay) => {
    setScrolling();
    if (clientStatus === 'deleted') {
      setRestrictionModal(true);
      return;
    }
    setCreditDaysLeft(100);
    history.push({ pathname: '/usage', state: { pay } });
  };

  const goToVideos = () => {
    setScrolling();
    if (clientStatus === 'deleted') {
      setRestrictionModal(true);
      return;
    }
    history.push('/videos');
  };

  const goToOfflineAssignments = () => {
    setScrolling();
    if (clientStatus === 'deleted') {
      setRestrictionModal(true);
      return;
    }
    history.push('/offlineassignments');
  };

  const goToCampaign = () => {
    setScrolling();
    if (clientStatus === 'deleted') {
      setRestrictionModal(true);
      return;
    }
    history.push('/campaign-dashboard');
  };

  const filteredCourses = allCourses
    .filter((ele) =>
      selectedCategory === 'all' ? true : ele.category_names.includes(selectedCategory),
    )
    .slice(0, 8);

  const getTodaysDate = () => {
    let yourDate = new Date();
    const offset = yourDate.getTimezoneOffset();
    yourDate = new Date(yourDate.getTime() - offset * 60 * 1000);
    return yourDate.toISOString().split('T')[0];
  };

  const renderComponents = useCallback(
    (param) => {
      if (param.switcher.includes('dynamicCard')) {
        return null;
        // roleArray.includes(3) || roleArray.includes(4) || roleArray.includes(5) ? (
        //   <DynamicCards
        //     boxshadow='0px 1px 3px 0px rgba(0, 0, 0, 0.16)'
        //     dynamicCardClicked={dynamicCardClicked}
        //     data={data[param.switcher]}
        //     titleData={data.feature[param.switcher]}
        //     noAddCard
        //     isDynamic
        //   />
        // ) : null;
      }
      if (param.switcher.includes('redirectCard')) {
        return (
          <Card
            className='DashboardCards'
            style={{
              border: '1px solid rgba(112,112,112,0.5)',
              margin: '10px auto',
              backgroundColor: param.start_colour,
            }}
          >
            <Row className='mx-0 justify-content-center mt-2'>
              <Col xs={8} className='text-left p-3'>
                <h6 className='Dummy__joinUs'>{param.client_feature_name}</h6>
                <p className='mb-0 mt-3 Dummy__joinDetails'>{param.description}</p>
              </Col>
              <Col xs={4} className='p-2' style={{ textAlign: 'right' }}>
                <img
                  src={param.feature_icon}
                  alt='form'
                  // style={{ width: '100px' }}
                  className='Dashboard_image shareImage'
                />
              </Col>
            </Row>
            <div className='Dashboard__admissionButtonContainer'>
              {data.admission_form_filled !== 'true' ? (
                <Button
                  variant='customPrimarySmol'
                  className='mb-3 fillAdmissionFormButton'
                  onClick={() => {
                    updateUsageTrack(clientId);
                    window.open(param.redirect_url, '_blank');
                  }}
                >
                  Go To Link
                </Button>
              ) : (
                <p
                  // style={{ textAlign: 'center' }}
                  className='Dashboard__attendanceSubHeading mb-3 text-center'
                >
                  You have completed your profile!
                </p>
              )}
            </div>
          </Card>
        );
      }
      switch (param.switcher) {
        case 'attendance':
          return (
            <div
              className='Dashboard__attendance px-2 py-1'
              onClick={() => gotToAttendance()}
              onKeyDown={() => gotToAttendance()}
              tabIndex='-1'
              role='button'
            >
              <div className='Dashboard__attendanceCard mx-auto pt-4'>
                <img
                  src={param.feature_icon}
                  alt='hands'
                  className='mx-auto d-block Dashboard__attendanceLogo'
                />
                <Row className='m-3 mb-0'>
                  <span className='Dashboard__todaysHitsText my-auto'>
                    {param.client_feature_name}
                  </span>
                  <span className='ml-auto'>
                    <ChevronRightIcon />
                  </span>
                </Row>

                <p className='Dashboard__attendanceSubHeading mx-3 pb-4 mb-0'>
                  {param.description}
                </p>

                {attendance.length > 0 && (
                  <div>
                    <hr />
                    <div>
                      <p className='Dashboard__attendanceRecents mx-3'>Recent Attendance</p>
                      <div className='mx-2 Dashboard__attendanceScrollable'>
                        {attendance.map((elem) => {
                          return (
                            <div className='d-flex flex-column mx-2' key={elem.batch_id}>
                              <img
                                src={userAvatar}
                                alt='batch'
                                height='35px'
                                width='35px'
                                className='Dashboard__noticeImage d-block mx-auto'
                              />
                              <p className='Dashboard__attendanceRecents text-center mt-1'>
                                {elem.batch_name}
                              </p>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          );
        case 'user_stats':
          return (
            <>
              <UserStats history={history} redirect={clientId == 2050} clientId={clientId} clientUserId={clientUserId} roleArray={roleArray} />
              {clientId == 2002 && (
                <FoldersDash clientId={clientId} clientUserId={clientUserId} history={history} />
              )}
            </>
          );
        case 'free_videos':
            return <>
              
             <FoldersDash clientId={clientId} clientUserId={clientUserId} history={history} /> </>
        case 'quiz':
          return (
            <>
              <Partition text='Quizes' className='mb-3' />{' '}
              <div
                style={{
                  width: '95%',
                  borderRadius: '9px',
                }}
                className='mx-auto mt-4'
                onClick={() => goToQuiz()}
                role='button'
                tabIndex='-1'
              >
                <h5 id='courses-section' className='pb-0 mt-2 mb-3 text-left fontBoldBold mx-auto'>
                  Daily Quiz
                </h5>
                <LazyLoadCustom
                  style={{ borderRadius: '9px' }}
                  src=''
                  className='w-100'
                />
              </div>
            </>
          );
        case 'donation':
          return (
            <>
              <div className='p-3'>
                <h5 id='courses-section' className='pb-0  text-left fontBoldBold mx-0'>
                  {languageObject.courses || 'Courses'}
                </h5>
                <img
                  role='buttom'
                  onClick={() => {
                    if (appLanguage === 2) {
                      history.push('/allCourses?category=हिंदी');
                    } else {
                      history.push('/allCourses?category=English');
                    }
                  }}
                  style={{ borderRadius: '10px' }}
                  className='w-100 my-2'
                  src=''
                />
              </div>
            </>
          );
        case 'courseCombo':
          return (
            <div
              className='Dashboard__donation mx-auto my-4'
              role='button'
              onClick={() => {
                if (appLanguage === 2) {
                  history.push('/allCourses?category=हिंदी');
                } else {
                  history.push('/allCourses?category=English');
                }
              }}
            >
              <h5 id='courses-section' className='pb-0 text-left fontBoldBold mx-0'>
                {languageObject.courses || 'Courses'}
              </h5>
              <div className='Dashboard__donationContent d-flex align-items-center'>
                <div className='Dashboard__donationImage'>
                  <LazyLoadCustom
                    src={
                      appLanguage === 1
                        ? 'https://d1z25xvwkfdh88.cloudfront.net/Production/1104/Utilities/course-banner-english.jpeg'
                        : 'https://d1z25xvwkfdh88.cloudfront.net/Production/1104/Utilities/course_banner-hindi.jpeg'
                    }
                    className='w-100'
                    style={{ maxWidth: '600px' }}
                  />
                </div>
              </div>
            </div>
          );
        case 'student_exams':
          return <MulyankanDash history={history} roleArray={roleArray} />; // very imp component, do not remove cause it will set the active tags to store
        case 'noticeBoard':
          return (
            <div
              className='Dashboard__noticeBoard mx-auto p-lg-3 p-2 my-3'
              onClick={() => goToNoticeBoard()}
              role='button'
              tabIndex='-1'
              style={{ backgroundColor: '#fffef4' }} // hardcoded by Aakash sir
              onKeyDown={() => goToNoticeBoard()}
            >
              <span className='Dashboard__verticalDots'>{/* <MoreVertIcon /> */}</span>
              <Row className='mt-2'>
                <Col xs={8} className='pl-4'>
                  <p className='Dashboard__todaysHitsText'>{param.client_feature_name}</p>
                  {(roleArray.includes(3) || roleArray.includes(4) || roleArray.includes(5)) && (
                    <Button style={{ backgroundColor: 'white' }} variant='noticeBoardPost'>
                      <BorderColorIcon />
                      <span className='m-2'>Write a post</span>
                    </Button>
                  )}
                  {(roleArray.includes(1) || roleArray.includes(2)) && (
                    <p className='Dashboard__attendanceSubHeading'>{param.description}</p>
                  )}
                </Col>
                <Col xs={4} className='noticeboard_img'>
                  <img src={param.feature_icon} alt='notice' className='Dashboard__NoticeIcon' />
                </Col>
              </Row>

              <Row className='mt-5 mx-2 mb-3'>
                <span className='Dashboard__noticeBoardText my-auto'>Latest Updates</span>

                <span className='ml-auto' style={{ color: 'rgba(117, 117, 117, 1)' }}>
                  <ChevronRightIcon />
                </span>
              </Row>

              {notices?.length > 0 ? (
                notices?.map((elem) => (
                  <div key={`elem${elem.notice_id}`} className='Dashboard__notice'>
                    <Row>
                      <Col xs={3} className='p-lg-4 py-3 text-center pr-0'>
                        <img
                          src={elem.profile_image ? elem.profile_image : userAvatar}
                          alt='profile'
                          className='Dashboard__noticeImage d-block mx-auto'
                        />
                      </Col>
                      <Col xs={9} className='pt-lg-4 py-3 pl-0 my-auto'>
                        <p className='Dashboard__scrollableCardHeading m-0'>
                          {`${elem.first_name} ${elem.last_name}`}
                        </p>
                        <p className='Dashboard__noticeSubHeading mb-0'>
                          {format(fromUnixTime(elem.time_of_notice), 'hh:m bbbb, do MMM yyy')}
                        </p>
                      </Col>
                    </Row>
                    <p
                      dangerouslySetInnerHTML={{ __html: urlify(detectNextLine(elem.notice_text)) }}
                      style={{ backgroundColor: '#fff4a4' }}
                      className='p-2 Dashboard__noticeText1'
                    ></p>
                  </div>
                ))
              ) : (
                <div>
                  <small className='mb-0 font text-muted '>No notices posted by admin</small>
                </div>
              )}
            </div>
          );
        case 'homeworkCreator':
          return (
            <div
              style={{
                background: `linear-gradient(90deg, ${param.end_colour}, ${param.start_colour})`,
              }}
              className='Dashboard__innovation pt-4 pl-3 pr-0 pb-3 mx-auto my-2'
            >
              <div>
                <p
                  style={{ cursor: 'pointer' }}
                  onClick={() => goToHomeWorkCreator()}
                  className='Dashboard__innovationpBlack ml-2'
                >
                  {param.client_feature_name}
                  <ChevronRightIcon />
                </p>
                <h4 className='Dashboard__innovationh4 ms-2'>Witness </h4>
                <h4 className='Dashboard__innovationh4 ms-2'>
                  The <span className='Dashboard__innovationh4span'>innovation</span>
                </h4>
                <p className='mr-5 Dashboard__innovationp ml-2'>
                  Create tests &amp; home-works in 4 simple steps
                </p>
                <Button
                  className='Dashboard_homeworkCreator btnLetsGo ml-2'
                  variant='dashboardHWletsGo'
                  onClick={() => goToHomeWorkCreator()}
                >
                  Let&apos;s go
                  <span>
                    <ChevronRightIcon />
                  </span>
                </Button>
              </div>
              <div className='Dashboard__assignment my-4 mr-2 Dashboard_homeworkCreator'>
                <section className='Dashboard__scrollableCard HWCdisplay'>
                  <div className='HWscrollableCard'>
                    <Row>
                      <Col xs={8} className='pr-0' onClick={() => goToSentTests('sent')}>
                        <p className='Dashboard__scrollableCardHeading pt-2 pl-3 mb-0'>
                          Sent Assignments
                        </p>
                        <p className='Dashboard__scrollableCardText pl-3 mt-1'>
                          All the tests &amp; homeworks sent to users are here...
                        </p>
                      </Col>
                      <Col xs={4} className='pt-3'>
                        <img
                          src={param.feature_icon}
                          alt='assignment'
                          className='savedSentCardImage'
                        />
                      </Col>
                    </Row>
                  </div>
                  <div className='HWscrollableCard2'>
                    <Row>
                      <Col xs={8} className='pr-0' onClick={() => goToSentTests('saved')}>
                        <p className='Dashboard__scrollableCardHeading pt-2 pl-3 mb-0'>
                          Saved Assignments
                        </p>
                        <p className='Dashboard__scrollableCardText pl-3 mt-1'>
                          See all your saved tests &amp; homeworks here...
                        </p>
                      </Col>
                      <Col xs={4} className='pt-3'>
                        <img
                          src={param.feature_icon}
                          alt='assignment'
                          className='savedSentCardImage'
                        />
                      </Col>
                    </Row>
                  </div>
                </section>
              </div>
            </div>
          );
        case 'analysis':
          return (
            <DashboardCards
              image={param.feature_icon} // analysisHands
              width={62}
              height={78}
              heading={
                param?.client_feature_name_object?.[`${appLanguage}`] ||
                param?.client_feature_name_object?.[`1`]
              }
              subHeading={
                param?.client_feature_description_object?.[`${appLanguage}`] ||
                param?.client_feature_description_object?.[`${appLanguage}`]
              }
              boxshadow='0px 1px 3px 0px rgba(0, 0, 0, 0.16)'
              backGround={param.start_colour}
              backgroundImg={`linear-gradient(90deg, ${param.start_colour} 0%, ${param.end_colour} 100%)`}
              buttonClick={role === 1 || role === 2 ? goToStudentAnalysis : goToTeacherAnalysis}
              textColor={data.text_color}
            />
          );
        case 'offlineAssignment':
          return (
            <DashboardCards
              image={param.feature_icon} // analysisHands
              width={62}
              height={78}
              heading={
                param?.client_feature_name_object?.[`${appLanguage}`] ||
                param?.client_feature_name_object?.[`1`]
              }
              subHeading={
                param?.client_feature_description_object?.[`${appLanguage}`] ||
                param?.client_feature_description_object?.[`${appLanguage}`]
              }
              boxshadow='0px 1px 3px 0px rgba(0, 0, 0, 0.16)'
              backGround={param.start_colour}
              backgroundImg={`linear-gradient(90deg, ${param.start_colour} 0%, ${param.end_colour} 100%)`}
              buttonClick={goToOfflineAssignments}
              textColor={data.text_color}
            />
          );
        case 'campaign':
          return (
           (role === 4 || role === 5) && <DashboardCards
              image={param.feature_icon} // analysisHands
              width={78}
              height={78}
              heading={
                param?.client_feature_name_object?.[`${appLanguage}`] ||
                param?.client_feature_name_object?.[`1`]
              }
              subHeading={
                param?.client_feature_description_object?.[`${appLanguage}`] ||
                param?.client_feature_description_object?.[`${appLanguage}`]
              }
              boxshadow='0px 1px 3px 0px rgba(0, 0, 0, 0.16)'
              backGround={param.start_colour}
              backgroundImg={`linear-gradient(90deg, ${param.start_colour} 0%, ${param.end_colour} 100%)`}
              buttonClick={goToCampaign}
              textColor={data.text_color}
            /> 
          );
        case 'fees':
          return (
            
              <DashboardCards
                image={param.feature_icon}
                width={53}
                height={78}
                heading={
                  param?.client_feature_name_object?.[`${appLanguage}`] ||
                  param?.client_feature_name_object?.[`1`]
                }
                subHeading={
                  param?.client_feature_description_object?.[`${appLanguage}`] ||
                  param?.client_feature_description_object?.[`${appLanguage}`]
                }
                boxshadow='0px 1px 3px 0px rgba(0, 0, 0, 0.16)'
                backGround={param.start_colour}
                backgroundImg={`linear-gradient(90deg, ${param.start_colour} 0%, ${param.end_colour} 100%)`}
                buttonClick={role === 1 || role === 2 ? goToFees : goToTeacherFees}
                textColor={data.text_color}
              />
            
          );
        case 'booking':
          return role > 2 ? (
            <DashboardCards
              image={param.feature_icon}
              width={78}
              height={78}
              heading={
                param?.client_feature_name_object?.[`${appLanguage}`] ||
                param?.client_feature_name_object?.[`1`]
              }
              subHeading={
                param?.client_feature_description_object?.[`${appLanguage}`] ||
                param?.client_feature_description_object?.[`${appLanguage}`]
              }
              boxshadow='0px 1px 3px 0px rgba(0, 0, 0, 0.16)'
              backGround={param.start_colour}
              backgroundImg={`linear-gradient(90deg, ${param.start_colour} 0%, ${param.end_colour} 100%)`}
              buttonClick={goToAppointmentBooking}
              textColor={data.text_color}
            />
          ) : (
            <>
              <div className='DashboardCards mx-auto'>
                <StudentAppointment history={history} />
              </div>
              {appointments.length > 0 && (
                <div className='mb-3 mb-md-4'>
                  <h1
                    id='courses-section'
                    className='pb-0 pt-5 mt-2 mb-4 text-center font-bold dashboardTitleh1 '
                  >
                    Appointments
                  </h1>

                  <div
                    style={appointments.length === 0 ? { minHeight: '300px' } : {}}
                    className='py-2 py-md-3 px-3 px-sm-5 position-relative appointments-grid1'
                  >
                    {appointments.map((ele, index) => (
                      <AppointmentCardNew
                        onClick={() => history.push(ele.sharePathname)}
                        key={index}
                        item={ele}
                      />
                    ))}
                  </div>
                </div>
              )}
            </>
          );
        case 'videos':
          return (
            <>
              <DashboardCards
                image={param.feature_icon}
                width={53}
                height={78}
                heading={
                  param?.client_feature_name_object?.[`${appLanguage}`] ||
                  param?.client_feature_name_object?.[`1`]
                }
                subHeading={
                  param?.client_feature_description_object?.[`${appLanguage}`] ||
                  param?.client_feature_description_object?.[`${appLanguage}`]
                }
                boxshadow='0px 1px 3px 0px rgba(0, 0, 0, 0.16)'
                backGround={param.start_colour}
                backgroundImg={`linear-gradient(90deg, ${param.start_colour} 0%, ${param.end_colour} 100%)`}
                buttonClick={goToVideos}
                textColor={data.text_color}
                uploadVideoText={`${
                  roleArray.includes(3) || roleArray.includes(4) || roleArray.includes(5)
                    ? 'Upload a video'
                    : ''
                }`}
                uploadVideoClicked={(e) => {
                  e.stopPropagation();
                  if (clientStatus === 'deleted') {
                    setRestrictionModal(true);
                    return;
                  }
                  history.push({ pathname: '/addyoutubevideo', state: { addVideo: true } });
                }}
              />
            </>
          );
        case 'posters':
          return data.posters.length > 0 && isMobile ? (
            <div className='mt-0 mb-4 pb-2 mt-2'>
              <Carousel
                controls={false}
                indicators={false}
                className='carousel_image'
                style={{
                  aspectRatio: '16/9',
                  borderRadius: '20px',
                  margin: 'auto',
                  maxWidth: '95vw',
                  overflow: 'hidden',
                  // maxHeight: '250px',
                }}
              >
                {data.posters.length > 0 &&
                  data.posters.map((elem, index) => (
                    <Carousel.Item
                      key={index}
                      style={{
                        height: 'auto',
                        width: '100%',
                        overflow: 'hidden',
                      }}
                      className='Scrollable__aspectCardBig'
                      interval={500}
                      onClick={() => {
                        if (elem.redirect_url) {
                          if (isWebView) {
                            window.location.href = elem.redirect_url;
                          } else if (isIosApp) {
                            iosRedirect(elem.redirect_url);
                          } else {
                            window.open(elem.redirect_url, '_blank');
                          }
                          updateUsageTrack(clientId);
                        }
                      }}
                    >
                      <div style={{ width: '100%', height: 'auto', overflow: 'hidden' }}>
                        {elem.file_type == 'image' && (
                          <LazyLoadCustom
                            className='header_img'
                            src={elem.file_link}
                            alt=''
                            style={{
                              // border: '2px solid blue',
                              borderRadius: '10px',
                              width: '100%',
                              height: 'auto',
                              // objectFit: 'contain',
                            }}
                          />
                        )}
                        {elem.file_type == 'video' && (
                          <video
                            // height={bigAspectCard ? '177px' : '113px'}
                            // width={bigAspectCard ? '315px' : '200px'}
                            style={{
                              // border: '2px solid blue',
                              borderRadius: '10px',
                              margin: 'auto',
                              overflow: 'hidden',
                              height: 'auto',
                              width: '100%',
                              // objectFit: 'cover',
                              // overflow:"hidden"
                            }}
                            muted
                            autoplay='autoplay'
                          >
                            <source src={formatVideoUrl(elem.file_link)} type='video/mp4' />
                            <track src='' kind='subtitles' srcLang='en' label='English' />
                          </video>
                        )}
                      </div>
                    </Carousel.Item>
                  ))}
              </Carousel>
            </div>
          ) : (
            <div className=' pt-4'>
              <AspectCards
                data={data.posters}
                clickCard={() => {}}
                clickAddCard={() => {}}
                section='notice'
                noAddCard
                bigAspectCard
                clientId={clientId}
              />
            </div>
          );
        case 'starPerformers':
          return null;
        case 'testimonial':
          return data.testimonials.length > 0 ? (
            <>
              <h6
                style={{
                  fontFamily: 'Montserrat-Bold',
                  lineHeight: '20px',
                  textAlign: 'left',
                  fontSize: '16px',
                }}
                className='mx-auto mx-auto mt-0 mb-0 scrollableCardHeading'
              >
                {param.client_feature_name}
              </h6>
              <AspectCards
                data={data.testimonials}
                clickCard={() => {}}
                clickAddCard={() => {}}
                section='notice'
                noAddCard
                clientId={clientId}
                // bigAspectCard
              />
            </>
          ) : null;
        case 'aboutUs':
          return null;
        case 'courses':
          return role === 1 || role === 2 ? (
            (allCourses.length > 0 || clientId == 1104) && (
              <>
                <div
                  style={{ width: '95%' }}
                  className='d-flex align-items-center mt-4 mx-auto justify-content-between'
                >
                  <h5 id='courses-section' className='pb-0  text-left fontBoldBold mx-0'>
                    {param.client_feature_name_object?.[`${appLanguage}`] ||
                      param.client_feature_name_object?.[`1`]}
                  </h5>
                  <span
                    role='button'
                    className='font mb-2'
                    onClick={() =>
                      history.push({ pathname: '/allcourses', state: { type: 'allCourses' } })
                    }
                  >
                    {languageObject.view_all || 'View All'} <ChevronRight />
                  </span>
                </div>
                {categories.length > 0 && categoryView === 'standard' ? (
                  <div className='d-flex mx-auto align-items-center gap-2 my-4 Dummy__categoryContainer'>
                    <div
                      onClick={() => setSelectedCategory('all')}
                      role='button'
                      className={`Dummy__categoryPill py-2 font ${
                        selectedCategory === 'all' ? 'Dummy__activePill' : ''
                      }`}
                    >
                      All{' '}
                      {param.client_feature_name_object?.[`${appLanguage}`] ||
                        param.client_feature_name_object?.[`1`]}
                    </div>
                    {categories.map((cat) => (
                      <div
                        key={cat}
                        onClick={() => setSelectedCategory(cat)}
                        role='button'
                        className={`Dummy__categoryPill py-2 font ${
                          selectedCategory === cat ? 'Dummy__activePill' : ''
                        }`}
                      >
                        {cat}
                      </div>
                    ))}
                  </div>
                ) : categories.length > 0 ? (
                  <div className='TilesView__grid mb-4 mt-3 mx-auto'>
                    {[...categories.map((cat) => ({ label: cat, value: cat }))].map(
                      ({ label, value }, index) => {
                        const isActive =
                          window.screen.width < 768
                            ? [0, 3, 4, 7, 8, 11, 12, 15, 16].includes(index)
                            : index % 2 === 0;
                        return (
                          <div
                            key={value}
                            className='TilesView__cell'
                            onClick={() =>
                              history.push({
                                pathname: '/allCourses',
                                search: `?category=${label}`,
                              })
                            }
                            role='button'
                          >
                            <div
                              className={`TilesView__card ${
                                isActive ? 'TilesView__card--active' : ''
                              }`}
                            >
                              <div className='TilesView__cardTitle font'>{label}</div>
                              <div className='TilesView__cardArrow'>
                                <span className='TilesView__arrowCircle'>&#8250;</span>
                              </div>
                            </div>
                          </div>
                        );
                      },
                    )}
                  </div> 
                ) : null}
                {categoryView === 'standard' && (
                  <div
                    style={filteredCourses.length === 0 ? { minHeight: '300px' } : {}}
                    className='py-0 px-0 px-md-2 px-lg-4 position-relative course-grid'
                  >
                    {filteredCourses.length === 0 ? (
                      <div className='text-center position-absolute w-100 py-5'>
                        <div className='text-center fs-5'>
                          <SearchSharp style={{ fontSize: '120px', color: '#ccc' }} />
                          <p
                            style={{ fontSize: '32px', color: 'var(--lighter-blue)' }}
                            className='font-bold mb-0'
                          >
                            No results found
                          </p>
                          <p className='font text-muted'>Please try a different category</p>
                        </div>
                      </div>
                    ) : (
                      filteredCourses.map((ele, index) => (
                        <CourseCardNew
                          languageObject={languageObject}
                          onClick={() => {
                            const isSubscribed =
                              ele.completed_percentage !== undefined &&
                              ele.completed_percentage !== null;
                            if (isSubscribed) {
                              goToMyCourse(ele.course_id);
                            } else {
                              goToBuyCourse(ele.course_id);
                            }
                          }}
                          key={index}
                          item={ele}
                        />
                      ))
                    )}
                  </div>
                )}
              </>
            )
          ) : (
            <DashboardCards
              image={param.feature_icon}
              width={51}
              height={78}
              heading={
                param?.client_feature_name_object?.[`${appLanguage}`] ||
                param?.client_feature_name_object?.[`1`]
              }
              subHeading={
                param?.client_feature_description_object?.[`${appLanguage}`] ||
                param?.client_feature_description_object?.[`${appLanguage}`]
              }
              boxshadow='0px 1px 3px 0px rgba(0, 0, 0, 0.16)'
              backgroundImg={`linear-gradient(90deg, ${param.start_colour} 0%, ${param.end_colour} 100%)`}
              backGround={param.start_colour}
              buttonClick={() => goToCoursesForTeacher(param.client_feature_name)}
              textColor={data.text_color}
            />
          );
        case 'myCourses':
          return (
            role === 1 &&
            clientId !== 1104 && (
              <CoursesCards
                allCourses={[]}
                myCourses={myCourses}
                goToCourse={goToCourses}
                buyCourseId={goToBuyCourse}
                myCourseId={goToMyCourse}
                yettostartCourseSelected={openYettostartCourseModal}
                clientLogo={branding.branding.client_logo}
                globalCurrency={branding.branding.currency_symbol}
                featureName={param.client_feature_name}
                featureDescription={param.description || undefined}
                country={currentCountry}
                state={currentState}
              />
            )
          );
        case 'liveClasses':
          return role === 3 || role === 4 || role === 5 ? (
            <DashboardCards
              image={param.feature_icon}
              width={91}
              height={73}
              heading={
                param?.client_feature_name_object?.[`${appLanguage}`] ||
                param?.client_feature_name_object?.[`1`]
              }
              subHeading={
                param?.client_feature_description_object?.[`${appLanguage}`] ||
                param?.client_feature_description_object?.[`${appLanguage}`]
              }
              boxshadow='0px 1px 3px 0px rgba(0, 0, 0, 0.16)'
              backGround={param.start_colour}
              backgroundImg={`linear-gradient(90deg, ${param.start_colour} 0%, ${param.end_colour} 100%)`}
              buttonText={
                roleArray.includes(3) || roleArray.includes(4) || roleArray.includes(5)
                  ? 'Go live now'
                  : ''
              }
              buttonClick={goToLiveClasses}
              textColor={data.text_color}
            />
          ) : (
            <>
              {studentLiveStream.length > 0 ? (
                <LiveClassesCards
                  firstName={firstName}
                  lastName={lastName}
                  liveClasses={studentLiveStream?.slice(0, 4)}
                  history={history}
                  clientId={clientId}
                  clientUserId={clientUserId}
                  dashboardData={dashboardData}
                />
              ) : (
                <DashboardCards
                  image={param.feature_icon}
                  width={91}
                  height={73}
                  heading={
                    param?.client_feature_name_object?.[`${appLanguage}`] ||
                    param?.client_feature_name_object?.[`1`]
                  }
                  subHeading={
                    param?.client_feature_description_object?.[`${appLanguage}`] ||
                    param?.client_feature_description_object?.[`${appLanguage}`]
                  }
                  boxshadow='0px 1px 3px 0px rgba(0, 0, 0, 0.16)'
                  backGround={param.start_colour}
                  backgroundImg={`linear-gradient(90deg, ${param.start_colour} 0%, ${param.end_colour} 100%)`}
                  buttonText={
                    roleArray.includes(3) || roleArray.includes(4) || roleArray.includes(5)
                      ? 'Go live now'
                      : ''
                  }
                  buttonClick={goToLiveClasses}
                  textColor={data.text_color}
                />
              )}
            </>
          );
        case 'onlineAssignment':
          return (
            <div>
              {clientStatus !== 'deleted' ? (
                <Tests
                  subHeading={param.description}
                  featureName={param.client_feature_name}
                  startHomework={startHomework}
                  startLive={startLiveTest}
                />
              ) : null}
            </div>
          );
        case 'studyBin':
          return (
            <>
              {clientId === 1104 && (
                <h5 style={{ width: '95%' }} className='px-1 fontBoldBold mb-0 mt-3 w-95 mx-auto'>
                  {languageObject.reading_material || 'Reading material'}
                </h5>
              )}
              <DashboardCards
                image={param.feature_icon} // student
                width={90}
                // height={86}
                heading={
                  param?.client_feature_name_object?.[`${appLanguage}`] ||
                  param?.client_feature_name_object?.[`1`]
                }
                subHeading={
                  param?.client_feature_description_object?.[`${appLanguage}`] ||
                  param?.client_feature_description_object?.[`${appLanguage}`]
                }
                color='rgba(0, 102, 255, 0.87)'
                backgroundImg={`linear-gradient(90deg, ${param.start_colour} 0%, ${param.end_colour} 100%)`}
                boxshadow='0px 1px 3px 0px rgba(0, 0, 0, 0.16)'
                buttonClick={goToStudyBin}
                textColor={data.text_color}
              />
            </>
          );
        case 'admissionForm':
          return data.admission_form_filled !== 'true' ? (
            <div
              className='ProfileStrip mx-auto'
              role='button'
              tabIndex={0}
              onClick={() => {
                if (clientStatus === 'deleted') {
                  setRestrictionModal(true);
                  return;
                }
                setScrolling();
                history.push('/admissionform');
              }}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '0 18px',
                height: '52px',
                backgroundColor: 'var(--lightest-blue)',
                borderRadius: '8px',
                border: '0.5px solid var(--primary-blue)',
                cursor: 'pointer',
                transition: 'background 0.18s, transform 0.15s',
                borderLeft: '3px solid var(--primary-blue)',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = 'var(--lighter-blue)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = 'var(--lightest-blue)';
              }}
            >
              {/* Left: dot + label + badge */}
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <span
                  style={{
                    width: '8px',
                    height: '8px',
                    borderRadius: '50%',
                    background: 'var(--primary-blue)',
                    flexShrink: 0,
                    boxShadow: '0 0 0 3px var(--lightest-blue)',
                  }}
                />
                <span style={{ fontSize: '14px', fontWeight: 500, color: 'inherit' }}>
                  {param.client_feature_name}
                </span>
                <span
                  style={{
                    fontSize: '11px',
                    fontWeight: 500,
                    background: '#E6F1FB',
                    color: 'var(--primary-blue)',
                    padding: '3px 9px',
                    borderRadius: '20px',
                  }}
                >
                  Action required
                </span>
              </div>

              {/* Right: hint text + arrow */}
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                  color: 'var(--primary-blue)',
                  fontSize: '13px',
                }}
              >
                <span style={{ fontSize: '16px' }}>→</span>
              </div>
            </div>
          ) : null;
        case 'share':
          return (
            <Card
              className='DashboardCards mb-2 mt-4'
              style={{
                border: '1px solid transparent',
                background: 'var(--lightest-blue)',
                margin: 'auto',
              }}
            >
              <Row className='mx-0 justify-content-center mt-2'>
                <Col xs={7} className='text-left p-3'>
                  <p className='Dummy__joinDetails font-bold mb-1 mb-md-2'>
                    <span style={{ color: 'var(--primary-blue)' }}>Enjoying</span> the application?
                  </p>
                  <h6 className='Dummy__connect font-bold mb-3 mb-md-5'>
                    Share app with <span style={{ color: 'var(--primary-blue)' }}>friends</span>
                  </h6>
                  <Button
                    variant='customPrimarySmol'
                    className='mb-3 fillAdmissionFormButton font'
                    onClick={() => shareThis()}
                  >
                    Share
                  </Button>
                </Col>
                <Col xs={5} className='p-3' style={{ textAlign: 'right' }}>
                  {/* share */}
                  <img
                    src={param.feature_icon}
                    alt='form'
                    className='Dashboard_image shareImageDash'
                  />
                </Col>
              </Row>
            </Card>
          );
        case 'contactUs':
          return (
            <div className='DashboardCards mx-auto my-4'>
              <div>
                <FAQ history={history} noHeader />
              </div>
              <Footer branding={branding.branding} dashboardDesign clientId={clientId} />
            </div>
          );
        case 'crm':
          return (
            <DashboardCards
              image={param.feature_icon} // analysis
              width={76}
              height={84}
              heading={
                param?.client_feature_name_object?.[`${appLanguage}`] ||
                param?.client_feature_name_object?.[`1`]
              }
              subHeading={
                param?.client_feature_description_object?.[`${appLanguage}`] ||
                param?.client_feature_description_object?.[`${appLanguage}`]
              }
              boxshadow='0px 1px 3px 0px rgba(0, 0, 0, 0.16)'
              backgroundImg={`linear-gradient(90deg, ${param.start_colour} 0%, ${param.end_colour} 100%)`}
              backGround={param.start_colour}
              textColor={data.text_color}
              buttonClick={goToCRM}
            />
          );
        case 'Usage':
          return (
            <>
              {Boolean(permissions.usage) && (
                <DashboardCards
                  image={param.feature_icon} // analysis
                  width={76}
                  height={84}
                  heading={
                    param?.client_feature_name_object?.[`${appLanguage}`] ||
                    param?.client_feature_name_object?.[`1`]
                  }
                  subHeading={
                    param?.client_feature_description_object?.[`${appLanguage}`] ||
                    param?.client_feature_description_object?.[`${appLanguage}`]
                  }
                  boxshadow='0px 1px 3px 0px rgba(0, 0, 0, 0.16)'
                  backgroundImg={`linear-gradient(90deg, ${param.start_colour} 0%, ${param.end_colour} 100%)`}
                  backGround={param.start_colour}
                  textColor={data.text_color}
                  buttonClick={goToUsage}
                />
              )}
            </>
          );
        case 'create_questions':
          return (
            <>
              <DashboardCards
                image={param.feature_icon} // analysis
                width={76}
                height={84}
                heading={
                  param?.client_feature_name_object?.[`${appLanguage}`] ||
                  param?.client_feature_name_object?.[`1`]
                }
                subHeading={
                  param?.client_feature_description_object?.[`${appLanguage}`] ||
                  param?.client_feature_description_object?.[`${appLanguage}`]
                }
                boxshadow='0px 1px 3px 0px rgba(0, 0, 0, 0.16)'
                backgroundImg={`linear-gradient(90deg, ${param.start_colour} 0%, ${param.end_colour} 100%)`}
                backGround={param.start_colour}
                textColor={data.text_color}
                buttonClick={() => history.push('/v2/homeworkcreator')}
              />
            </>
          );
        case 'admission':
          return (
            Object.keys(admissions).length > 0 && (
              <>
                {(
                  <DashBoardAdmissions
                    dashboardData={dashboardData}
                    admissions={admissions}
                    goToAddBatch={goToAddBatch}
                    goToAdmissions={goToAdmissions}
                    openOptionsModal={openOptionsModal}
                    heroImage={param.feature_icon}
                    heading={param.client_feature_name}
                    subHeading={param.description}
                  />
                ) || <Skeleton count={20} />}
              </>
            )
          );
        case 'displayPage':
          return (
            <DashboardCards
              image={param.feature_icon} // student
              width={78}
              height={76}
              heading={
                param?.client_feature_name_object?.[`${appLanguage}`] ||
                param?.client_feature_name_object?.[`1`]
              }
              subHeading={
                param?.client_feature_description_object?.[`${appLanguage}`] ||
                param?.client_feature_description_object?.[`${appLanguage}`]
              }
              color='rgba(255, 236, 222, 1)'
              boxshadow='0px 1px 3px 0px rgba(0, 0, 0, 0.16)'
              backgroundImg={`linear-gradient(90deg, ${param.start_colour} 0%, ${param.end_colour} 100%)`}
              buttonClick={goToDisplayPage}
              textColor={data.text_color}
            />
          );
        case 'connectWithUs':
          null;
        case 'chats':
          if (clientId === 2050 && roleArray.every((ele) => ele < 3)) {
            return <ChatbotButton showBadge={true} history={history} />;
          }
          // window.screen.width < 768 && clientId != 1782 &&
          // clientId != 1713 &&
          // clientId != 2002 &&
          // clientId != 137 &&
          // clientId !== 1104 &&
          // clientId !== 2050 ? (
          return window.screen.width < 768 && dashboardData?.feature?.chats?.status === 'active' ? (
            <>
              <Button
                variant='customPrimary'
                onClick={goToChats}
                style={{ bottom: isIosApp ? '107px' : '75px' }}
                className='floatingChatButtonDashboard'
              >
                {languageObject.lets_chat || "Let's Chat"}
              </Button>

              {globalMessageCountState > 0 && (
                <div
                  className='dotOnFloatingButton'
                  style={{ bottom: isIosApp ? '147px' : '115px' }}
                >
                  {globalMessageCountState}
                </div>
              )}
            </>
          ) : null;
        default:
          return null;
      }
    },
    [
      clientStatus,
      roleArray,
      role,
      data,
      notices,
      attendance,
      allCourses,
      myCourses,
      branding,
      studentLiveStream,
      admissions,
      isMobile,
      categories,
      selectedCategory,
      filteredCourses,
      colors,
    ],
  );

  // dashboard scrolling saving in cache
  useEffect(() => {
    // if (roleArray.includes(4)) {
    get({ client_user_id: clientUserId }, '/getRoleArray').then((res) => {
      if (res && res.success) {
        setRoleArrayToStore(res.result);
      }
    });
    // }
  }, []);

  const getPermissions = (perm) => {
    setPermissions(perm);
  };

  return (
    <div className='Dashboard__mainContainerDiv pt-1'>
      <PageHeaderNew history={history} darker={isScrolled} getPermissions={getPermissions} />
      <BackdropLoader isLoading={isLoading} />
      {Math.round(new Date().getTime() / 1000) < 1789617600 && (roleArray.includes(4) || roleArray.includes(5)) && <div className='Dashboard__topmaintenanceBar'>
        <p className='mb-0 Dashboard__maintenanceText'>
          Scheduled maintenance from 1:00 AM to 2:00 AM on 17th September 2026
        </p>
      </div>}
      {false ? (
        <div className='Dashboard__maintenanceBar'>
          <p className='mb-0'>
            Scheduled maintenance from 1:00 AM to 2:00 AM on 17th September 2026
          </p>
        </div>
      ) : (roleArray.includes(4) || roleArray.includes(5)) && isLowBalance ? (
        <>
          <div onClick={() => history.push('/usage')} className='Dashboard__redUpdateTop'>
            <p className='mb-0'>
              <span className='Dashboard__alertIcon'>ALERT</span> Low Credit Balance!
              <span className='Dashboard__blueLink'>
                <u>
                  <b>Recharge now</b>
                </u>
              </span>
            </p>
          </div>
        </>
      ) : null}
      <div className='Dashboard__headerCard d-block d-md-none pb-3'>
        {hasLoaded && (
          <h3 className='Dashboard__coachingName text-center'>
            {data?.language_name?.[`${appLanguage}`] ||
              data?.language_name?.[`1`] ||
              data.client_name}
          </h3>
        )}
        {hasLoaded && (
          data.client_tag_line && <p className='Dummy__tagline  text-center'>
            {data?.language_tagline?.[`${appLanguage}`] ||
              data?.language_tagline?.[`1`] ||
              data.client_tag_line}
          </p>
        )}
      </div>

      {hasLoaded &&
        features.length > 0 &&
        features
          .filter((elem) => process.env.NODE_ENV === 'developmentt' || elem.status === 'active')
          .map((elem) => renderComponents(elem))}

      <Modal show={optionsModal} onHide={closeOptionsModal} size='lg' centered>
        <Modal.Header closeButton>
          <Modal.Title>Select Type</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='mx-0 d-flex w-100 justify-content-between flex-wrap'>
            <Button
              variant='noticeBoardPost'
              style={{ paddingRight: '10px', paddingLeft: '10px' }}
              onClick={() => addDetails('student')}
            >
              <PersonAddIcon />
              <span>{dashboardData.role_name_array?.student}</span>
            </Button>
            <Button
              variant='noticeBoardPost'
              style={{ paddingRight: '10px', paddingLeft: '10px' }}
              onClick={() => {
                addDetails('teacher');
              }}
            >
              <PersonAddIcon />
              <span className=''>{dashboardData.role_name_array?.teacher}</span>
            </Button>

            <Button
              style={{ paddingRight: '10px', paddingLeft: '10px' }}
              variant='noticeBoardPost'
              onClick={() => {
                addDetails('admin');
              }}
            >
              <PersonAddIcon />
              <span className=''>{dashboardData.role_name_array?.admin}</span>
            </Button>
          </div>
        </Modal.Body>
      </Modal>
      <Modal show={restrictionModal} onHide={() => setRestrictionModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Features Inaccessible?</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className='connectWithUsText'>
            Services may be suspended due to non-renewal of subscription. Please contact your
            institute for uninterrupted services on your web app.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={goToChats} variant='boldText'>
            Meanwhile, interact with your friends!
          </Button>
        </Modal.Footer>
      </Modal>
      <YettostartCourseModal
        course={yettostartCourse}
        onHide={() => setYettostartCourse(null)}
      />
      <Modal show={!sessionStatus} backdrop='static' keyboard={false} centered>
        <Modal.Header>
          <Modal.Title>Hey There</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className='connectWithUsText'>
            Previous session expired. Looks like you have logged in some other device.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={logout} variant='boldText'>
            Login again
          </Button>
        </Modal.Footer>
      </Modal>
      <Toast
        style={{
          position: 'fixed',
          bottom: '20px',
          right: '15%',
          zIndex: '999',
        }}
        onClose={() => setShowToast(false)}
        show={showToast}
        delay={3000}
        autohide
      >
        <Toast.Header>
          <strong className='mr-auto'>Copied!</strong>
          <small>Just Now</small>
        </Toast.Header>
        <Toast.Body>The link has been copied to your clipboard!</Toast.Body>
      </Toast>
      <Toast
        style={{
          position: 'fixed',
          top: '20px',
          right: '15%',
          zIndex: '999',
        }}
        onClose={() => setIsToken(true)}
        show={!isToken}
        delay={5000}
        autohide
      >
        <Toast.Header>
          <strong className='mr-auto'>Notifications</strong>
          <small>Just Now</small>
        </Toast.Header>
        <Toast.Body>
          Please allow notifications to receive prompt updates and important notifications
        </Toast.Body>
      </Toast>
      {(hasLoaded && roleArray.includes(4)) || roleArray.includes(5) ? (
        <p className='connectWithUsText'>
          Having an issue?
          <br />{' '}
          <a className='connectText' href='tel:+918851303866'>
            Connect
          </a>{' '}
          {/* with us! */}
          with us or
          <span
            role='button'
            tabIndex={-1}
            onKeyDown={redirectToWhatsapp}
            onClick={redirectToWhatsapp}
            className='callbackText'
          >
            {' '}
            chat with us now!
          </span>
        </p>
      ) : null}
      <>
        <br />
        <br />
        <BottomNavSpacer />
      </>
      <BottomNavigation activeNav='home' history={history} />

      <Modal show={showCallbackModal} onHide={closeCallbackModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Request a callback</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <p className='Dummy__joinSmall'>Please fill all the details below.</p>
            <div className='d-flex w-100 justify-content-between'>
              <label style={{ margin: '0px 10px 0px 0px' }} className='has-float-label mb-3 w-100'>
                <select
                  className='form-control w-100'
                  name='Preferred Slot'
                  style={{ maxHeight: '32px' }}
                  onChange={(e) => setSelectedSlot(e.target.value || '9:00 AM - 11:00 AM')}
                >
                  {slots.map((ele) => {
                    return <option value={ele}>{ele}</option>;
                  })}
                </select>
                <span>Preferred Slot</span>
                {false ? (
                  <p className='alertTextRegionalPrice'>* Please select a preferred slot</p>
                ) : null}
              </label>
              <label style={{ margin: '0px 0px 0px 10px' }} className='has-float-label mb-3 w-100'>
                <input
                  className='form-control'
                  name='Preferred Date'
                  type='date'
                  value={selectedDate}
                  min={getTodaysDate()}
                  placeholder='Preferred Date'
                  onChange={(e) => setSelectedDate(e.target.value)}
                />
                <span>Preferred Date</span>
                {false ? (
                  <p className='alertTextRegionalPrice'>* Please select a preferred date</p>
                ) : null}
              </label>
            </div>
            <label className='has-float-label mb-3'>
              <input
                className='form-control'
                name='Contact'
                type='text'
                value={callbackContact}
                placeholder='Contact'
                onChange={(e) => setCallbackContact(e.target.value)}
              />
              <span className='smallFont'>Contact</span>
            </label>
            <label className='has-float-label mb-3'>
              <input
                className='form-control'
                name='Feedback (optional)'
                type='textarea'
                value={issueDescription}
                placeholder='Describe your issue'
                onChange={(e) => setIssueDescription(e.target.value)}
              />
              <span className='smallFont'>Describe your issue</span>
            </label>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant='boldTextSecondary' onClick={closeCallbackModal}>
            Cancel
          </Button>
          <Button
            disabled={!issueDescription || !callbackContact || !selectedDate}
            variant='boldText'
            onClick={sendClientTicket}
          >
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal size='sm' show={logginOutModal} backdrop='static' centered>
        <Modal.Body className='text-center d-flex align-items-center justify-content-center'>
          <Spinner animation='border' role='status'>
            <span className='visually-hidden' />
          </Spinner>
          <p
            className='text-left mb-0 ml-2'
            style={{ padding: '10px', fontFamily: 'Montserrat-Regular' }}
          >
            Session expired <br />
            Loggin you out...
          </p>
        </Modal.Body>
      </Modal>
      <Modal
        className='justify-content-center lowBalanceModal'
        show={creditsDaysLeft <= 3}
        onHide={() => {
          setCreditDaysLeft((prev) => prev * 10);
        }}
        centered
      >
        <Modal.Body>
          <div className='w-100 mb-3 text-center'>
            <WarningAmberOutlined style={{ color: '#d60004', fontSize: '52px' }} />
          </div>
          <p className='font mb-1 text-center'>
            Estimated{' '}
            <span className='font-bold'>
              {Math.ceil(creditsAvailable / Number(dashboardData.averageConsumption))}{' '}
            </span>
            days remaining
          </p>
          <p className='font mb-0 text-center'>
            Credits Left: <span className='font-bold'>{Number(creditsAvailable)?.toFixed(2)}</span>
          </p>
        </Modal.Body>
        <Modal.Footer className='justify-content-center py-2'>
          <Button
            onClick={() => goToUsage(true)}
            style={{ border: 'transparent' }}
            className='font-bold'
            variant='customSecondary'
          >
            Recharge Now
          </Button>
        </Modal.Footer>
      </Modal>
      {/* {roleArray.includes(4) || roleArray.includes(5) ? (
        <div onClick={() => history.push('/campaign')} className='Dashboard__updateBottomDash'>
          <p className='mb-0'>
            <IconButton className='Dashboard__campicon'>
              <Email style={{ fontSize: '18px' }} className='mx-2' />
            </IconButton>{' '}
            <span>Email Campaign Launched!</span>
            <span className='Dashboard__blueLink'>
              <u>
                <b>Try now</b>
              </u>
            </span>
          </p>
        </div>
      ) : null} */}
    </div>
  );
};

const mapStateToProps = (state) => ({
  userProfile: getUserProfile(state),
  dashboardData: getCurrentDashboardData(state),
  clientId: getClientId(state),
  clientUserId: getClientUserId(state),
  roleArray: getRoleArray(state),
  branding: getCurrentBranding(state),
  comeBackFromTests: getComeBackFromTests(state),
  redirectPath: getCurrentRedirectPath(state),
  firstTimeLogin: getFirstTimeLoginState(state),
  scrolledHeight: getCurrentSccrolledHeight(state),
  creditsAvailable: getCreditsAvailable(state),
  subscribedTopicsArray: getSubscribedTopicsArray(state),
  languageObject: getLanguageObject(state),
  appLanguage: getAppLanguage(state),
});

const mapDispatchToProps = (dispatch) => ({
  clearClientIdDetails: () => {
    dispatch(clientUserIdActions.clearClientIdDetails());
  },

  clearProfile: () => {
    dispatch(userProfileActions.clearUserProfile());
  },
  setFirstTimeLoginToStore: () => {
    dispatch(firstTimeLoginActions.setFirstTimeLoginToStore());
  },

  setTestIdToStore: (payload) => {
    dispatch(testsActions.setTestIdToStore(payload));
  },
  setTestTypeToStore: (payload) => {
    dispatch(testsActions.setTestTypeToStore(payload));
  },
  setTestStartTimeToStore: (payload) => {
    dispatch(testsActions.setTestStartTimeToStore(payload));
  },
  setTestEndTimeToStore: (payload) => {
    dispatch(testsActions.setTestEndTimeToStore(payload));
  },
  setTestResultArrayToStore: (payload) => {
    dispatch(testsActions.setTestResultArrayToStore(payload));
  },
  setFileUrlToStore: (payload) => {
    dispatch(testsActions.setFileUrlToStore(payload));
  },
  setTestFormatToStore: (payload) => {
    dispatch(testsActions.setTestFormatToStore(payload));
  },
  setTestAnalysisTimeToStore: (payload) => {
    dispatch(testsActions.setTestAnalysisTimeToStore(payload));
  },
   setTestNameToStore: (payload) => {
    dispatch(testsActions.setTestNameToStore(payload));
  },
  setTestLanguageToStore: (payload) => {
    dispatch(testsActions.setTestLanguageToStore(payload));
  },
  setCourseIdToStore: (payload) => {
    dispatch(courseActions.setCourseIdToStore(payload));
  },
  setAdmissionRoleArrayToStore: (payload) => {
    dispatch(admissionActions.setAdmissionRoleArrayToStore(payload));
  },
  setHomeworkLanguageTypeToStore: (payload) => {
    dispatch(homeworkActions.setHomeworkLanguageTypeToStore(payload));
  },
  setFolderIdArrayToStore: (payload) => {
    dispatch(studyBinActions.setFolderIDArrayToStore(payload));
  },
  setDashboardDataToStore: (payload) => {
    dispatch(dashboardActions.setDashboardDataToStore(payload));
  },
  setLocationDataToStore: (payload) => {
    dispatch(dashboardActions.setLocationDataToStore(payload));
  },
  setAnalysisStudentObjectToStore: (payload) => {
    dispatch(analysisActions.setAnalysisStudentObjectToStore(payload));
  },
  setSelectedCourseToStore: (payload) => {
    dispatch(homeworkActions.setSelectedCourseToStore(payload));
  },
  clearTests: (payload) => {
    dispatch(homeworkActions.clearTests(payload));
  },
  setSelectedSubjectToStore: (payload) => {
    dispatch(homeworkActions.setSelectedSubjectToStore(payload));
  },
  setSelectedChapterToStore: (payload) => {
    dispatch(homeworkActions.setSelectedChapterToStore(payload));
  },
  setSelectedTypeToStore: (payload) => {
    dispatch(homeworkActions.setSelectedTypeToStore(payload));
  },
  setEomrFileUrlToStore: (payload) => {
    dispatch(homeworkActions.setEomrFileUrlToStore(payload));
  },
  setEomrSolutionFileUrlToStore: (payload) => {
    dispatch(homeworkActions.setEomrSolutionFileUrlToStore(payload));
  },
  setTokenToStore: (payload) => {
    dispatch(dashboardActions.setTokenToStore(payload));
  },
  setScrolledHeightOfDocumentToStore: (payload) => {
    dispatch(dashboardActions.setScrolledHeightOfDocumentToStore(payload));
  },
  setSubscribedTopicsArrayToStore: (payload) => {
    dispatch(dashboardActions.setSubscribedTopicsArrayToStore(payload));
  },
  setRoleArrayToStore: (payload) => {
    dispatch(clientUserIdActions.setRoleArrayToStore(payload));
  },
  setNavbarDataToStore: (payload) => {
    dispatch(dashboardActions.setNavbarDataToStore(payload));
  },
  setSelectedQuestionArrayToStore: (payload) => {
    dispatch(homeworkActions.setSelectedQuestionArrayToStore(payload));
  },
  setCourseActiveTabToStore: (payload) => {
    dispatch(courseActions.setCourseActiveTabToStore(payload));
  },
  setActiveTagsToStore: (payload) => {
    dispatch(dashboardActions.setActiveTagsToStore(payload));
  },
  setGlobalMessageCountToStore: (payload) => {
    dispatch(conversationsActions.setGlobalMessageCount(payload));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);

Dashboard.propTypes = {
  clientId: PropTypes.number.isRequired,
  dashboardData: PropTypes.instanceOf(Object).isRequired,
  clientUserId: PropTypes.number.isRequired,
  clearProfile: PropTypes.func.isRequired,
  scrolledHeight: PropTypes.func.isRequired,
  clearClientIdDetails: PropTypes.func.isRequired,
  setTestResultArrayToStore: PropTypes.func.isRequired,
  setTestEndTimeToStore: PropTypes.func.isRequired,
  setTestStartTimeToStore: PropTypes.func.isRequired,
  setTestIdToStore: PropTypes.func.isRequired,
  setFirstTimeLoginToStore: PropTypes.func.isRequired,
  setTestTypeToStore: PropTypes.func.isRequired,
  setHomeworkLanguageTypeToStore: PropTypes.func.isRequired,
  setTestLanguageToStore: PropTypes.func.isRequired,
  setCourseIdToStore: PropTypes.func.isRequired,
  setDashboardDataToStore: PropTypes.func.isRequired,
  setLocationDataToStore: PropTypes.func.isRequired,
  setAdmissionRoleArrayToStore: PropTypes.func.isRequired,
  setAnalysisStudentObjectToStore: PropTypes.func.isRequired,
  setFolderIdArrayToStore: PropTypes.func.isRequired,
  setTokenToStore: PropTypes.func.isRequired,
  clearTests: PropTypes.func.isRequired,
  userProfile: PropTypes.shape({
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    profileImage: PropTypes.string,
    contact: PropTypes.string,
    countryCode: PropTypes.string,
  }).isRequired,
  roleArray: PropTypes.instanceOf(Array).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  branding: PropTypes.instanceOf(Object).isRequired,
  comeBackFromTests: PropTypes.bool.isRequired,
  redirectPath: PropTypes.string.isRequired,

  firstTimeLogin: PropTypes.bool.isRequired,

  setSelectedCourseToStore: PropTypes.func.isRequired,
  setSelectedChapterToStore: PropTypes.func.isRequired,
  setSelectedTypeToStore: PropTypes.func.isRequired,
  setSelectedSubjectToStore: PropTypes.func.isRequired,
  setScrolledHeightOfDocumentToStore: PropTypes.func.isRequired,
  setTestAnalysisTimeToStore: PropTypes.func.isRequired,
  setSubscribedTopicsArrayToStore: PropTypes.func.isRequired,
  setRoleArrayToStore: PropTypes.func.isRequired,
  setFileUrlToStore: PropTypes.func.isRequired,
  subscribedTopicsArray: PropTypes.instanceOf(Object).isRequired,
};
